module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Down-left-0aa2404fbe10cdbb7633432f1b7701d4.svg";